import { PatchworkApiReturnCodes, PatchworkRESTApiError } from "@patchwork/api/apireturncodes";
import { login } from "@patchwork/api/user/userapi";

async function tryLogin() {
	let errorHint = document.getElementById("login-error-hint") as HTMLParagraphElement;
	if (errorHint) {
		errorHint.hidden = true;
	}
	let loginInput = document.getElementById("login") as HTMLInputElement; 
	let passwordInput = document.getElementById("password") as HTMLInputElement; 
	if (loginInput && passwordInput) {

		if (!loginInput.checkValidity()) {
			loginInput.reportValidity();
			return;
		}
		if (!passwordInput.checkValidity()) {
			passwordInput.reportValidity();
			return;
		}

		var result = await login(loginInput.value, passwordInput.value);
		if (result.unpack()) {
			window.location.replace("/home");
		} else {
			var error = result.error() as PatchworkRESTApiError;
			console.log(error);
			if (error && errorHint) {
				if (error.errorCode === PatchworkApiReturnCodes.USERMAILNOTVERIFIEDEXCEPTION) {
					errorHint.innerText = "Votre email n'a pas été vérifié.";
				}
				errorHint.hidden = false;
			}
		}
	}
}


declare global {
	interface Window {
		loginPage : {
			tryLogin : () => void
		}
	}
}


window.loginPage = window.loginPage || {tryLogin : tryLogin};

